// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","burgerBar1":"_1pJfe","burgerBar2":"_2TOFW","burgerBar3":"_1ZtRm","burgerContainer":"_2lVQa","burgerCross":"_30u_l"};